import request from '@/utils/request'

/**
 * 获取基本信息
 */
export function getStationInfo(stationId,date) {
  return request({
    url: `/device/station/custom/info/${stationId}?date=${date}`,
    method: 'get',
  })
}

/**
 * 获取收益总览
 */
export function getOverview(params) {
  return request({
    url: `/dashboard/v3/ops/daily/single/queryOverview`,
    method: 'get',
    params: params
  })
}

/**
 * 获取充电汇总
 */
export function getChargeSummary(params) {
    return request({
      url: `/dashboard/v3/ops/charge/records/query`,
      method: 'get',
      params: params
    })
  }
/**
 * 获取分时收益数据（测试接口）
 */
export function getTimeSharingIncome(params) {
    return request({
      url: `/job/time-sharing-income/daily/query`,
      method: 'get',
      params: params
    })
  }


  /**
   * 获取日报数据
   */
  export function getDailySummary(params) {
    return request({
      url: `/dashboard/v3/ops/daily/single/query`,
      method: 'get',
      params: params
    })
  }
  
/**
 * 获取需量曲线的配置
 * >>> 3个分组: 实际需量 | 储能需量 | 负荷需量
 * >>> 分组下每项对应一条曲线的配置
 * @param {*} stationId 
 * @returns 
 */
/** 需量曲线：data 下多为 actualDemand / energyDemand / loadDemand，兼容 *List 命名 */
export async function queryLinesOption(stationId, date) {
  const sid = stationId != null && stationId !== '' ? String(stationId).trim() : ''
  const d = date != null && String(date).trim() !== '' ? String(date).trim().slice(0, 10) : ''
  if (!sid || !d) {
    return Promise.resolve({
      cycle: undefined,
      slip: undefined,
      actualDemand: [],
      energyDemand: [],
      loadDemand: []
    })
  }
  return request({
    url: `/dashboard/meter/demand/analysis/getDataList`,
    method: 'get',
    params: {
      stationId: sid,
      date: d
    }
  })
    .then((res) => {
      const d = res?.data ?? {}
      return {
        cycle: d.cycle,
        slip: d.slip,
        actualDemand: d.actualDemand ?? d.actualDemandList ?? [],
        energyDemand: d.energyDemand ?? d.energyDemandList ?? [],
        loadDemand: d.loadDemand ?? d.loadDemandList ?? []
      }
    })
    .catch((err) => {
      console.error(err)
      return {
        cycle: undefined,
        slip: undefined,
        actualDemand: [],
        energyDemand: [],
        loadDemand: []
      }
    })
}


/** 获取满充容量统计 */
export function getChargeRecords(params) {
  return request({
    url: `/dashboard/dataAnalysis/charge/records`,
    method: 'get',
    params: params
  })
}

/** 告警统计 */
export function getAlertList(params) {
  return request({
    url: `/dashboard/v3/ops/daily/single/queryStatisticalAlarm`,
    method: 'get',
    params: params
  })
}

/**
 * 获取今日收益
 */
export function getTodayIncome(params) {
  return request({
    url: `/dashboard/v3/ops/today/income/query`,
    method: 'get',
    params: params
  })
}

/**
 * 获取电站能源统计
 */
export function getStationEnergyStat(params) {
  return request({
    url: `/dashboard/dataAnalysis/stations/energy`,
    method: 'get',
    params: params
  })
}


/** 获取现货电价模板 */

export function getSpotPriceTemplate(params) {
  return request({
    url: `/dashboard/v3/price/snapshot/importTemplate`,
    method: 'get',
    params: params,
    responseType: 'blob',
  })
}

/** 导入现货电价快照 Excel（multipart/form-data，字段名 file；仅该路径在 request 拦截器内去掉默认 JSON Content-Type） */
export function importSpotPriceTemplate(formData) {
  return request({
    url: `/dashboard/v3/price/snapshot/import`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/** 导出现货电价数据 */
export function exportSpotPriceData(params) {
  return request({
    url: `/dashboard/v3/price/snapshot/export`,
    method: 'post',
    params: params,
    responseType: 'blob',
  })
}

/** 获取现货电价数据 */
export function getSpotPriceData(params) {
  return request({
    url: `/dashboard/v3/price/snapshot/area`,
    method: 'get',
    params: params
  })
}

/** 新增现货电价数据 */
export function addSpotPriceData(params) {
  return request({
    url: `/dashboard/v3/price/snapshot/batch`,
    method: 'post',
    data: params
  })
}

/** 修改现货电价数据 */
export function updateSpotPriceData(params) {
  return request({
    url: `/dashboard/v3/price/snapshot`,  
    method: 'put',
    data: params
  })
}

/** 删除现货电价数据 */
export function deleteSpotPriceData(id) {
  return request({
    url: `/dashboard/v3/price/snapshot/${id}`,
    method: 'delete',
  })
}


/** 获取现货历史电价数据 */
export function getHistoryPriceData(params) {
  return request({
    url: `/dashboard/v3/price/snapshot/list`,
    method: 'get',
    params: params
  })
}

export function queryProvinceSegmentsInfo(year,month, provinceCode) {
  return request({
    url: `/command/meterRatePeriod/getStandard`,
    method: 'get',
    params: {
      year,
      month,
      provinceCode,
    }
  })
}





